/**
 * Segments de route Angular (sans slash initial) pour {@code Routes}.
 */
export const APP_ROUTE_SEGMENTS = {
  accueil: 'accueil',
  logements: 'logements',
  ajoutLogements: 'ajout-logements',
  unites: 'unites',
  dossierTechnique: 'dossier-technique',
  contacts: 'contacts',
  ajoutContacts: 'ajout-contacts',
  locataires: 'locataires',
  ajoutLocataires: 'ajout-locataires',
} as const;

/**
 * Chemins absolus pour {@code routerLink} / {@code navigate}.
 */
export const APP_ROUTES = {
  accueil: `/${APP_ROUTE_SEGMENTS.accueil}`,
  logements: `/${APP_ROUTE_SEGMENTS.logements}`,
  ajoutLogements: `/${APP_ROUTE_SEGMENTS.ajoutLogements}`,
  contacts: `/${APP_ROUTE_SEGMENTS.contacts}`,
  ajoutContacts: `/${APP_ROUTE_SEGMENTS.ajoutContacts}`,
  locataires: `/${APP_ROUTE_SEGMENTS.locataires}`,
  ajoutLocataires: `/${APP_ROUTE_SEGMENTS.ajoutLocataires}`,
  dossierTechnique: (bienId: string, logementId: string) =>
    `/${APP_ROUTE_SEGMENTS.logements}/${bienId}/${APP_ROUTE_SEGMENTS.unites}/${logementId}/${APP_ROUTE_SEGMENTS.dossierTechnique}`,
} as const;
